import request from '@webtrader/core/request';

export enum ESymbolType {
  FOREX = 'FOREX',
  INDEX = 'INDEX',
  CRYPTO = 'CRYPTO',
  SHARES = 'SHARE',
  OTHERS = 'OTHER',
  COMMODITIES = 'COM'
}

export enum ESymbolStatus {
  TRADING = 'TRADING',
  CLOSED = 'CLOSED',
  OFFQUOTES = 'OFFQUOTES'
}

export enum EOptionSymbolSide {
  PUT = 'PUT',
  CALL = 'CALL'
}

export interface IHorizonSymbolTickRulesGroup {
  startTickPriceRange: number;
  tickIncrement: number;
}

export interface IMiniChart {
  chartTime: number;
  open: number;
}

export interface ISymbol {
  ask: number;
  bid: number;
  low: number;
  high: number;
  open: number;
  type: ESymbolType;
  price: number;
  watch: boolean;
  symbol: string;
  status: ESymbolStatus;
  online: boolean;
  decimal: number;
  description: string;
  lastUpdated: number;
  symbolGroup: string;
  miniChart: IMiniChart[];
}

export default {
  symbols: () => request.get<ISymbol[]>('/api/market/v1/symbols'),
  allSymbols: () => request.get<ISymbol[]>('/api/market/v1/symbols/all')
};
